(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    document.addEventListener("DOMContentLoaded", function() {
        var body = document.getElementsByTagName('body')[0];

        /* HOME JS */
        if (body.classList.contains('home')){
            /* HOME SLIDER */
            setTimeout(function(){
                var dotsImages = document.querySelectorAll('#slides-images .swiper-pagination-bullet');
                var dotsTexts = document.querySelectorAll('#slides-texts .swiper-pagination-bullet');
                var loop = function ( di ) {
                    dotsImages[di].addEventListener('click', function(){
                        dotsTexts[di].click();
                    });
                };

                for (var di = 0; di < dotsImages.length; di++)loop( di );
            }, 500);
            /* HOME PUBLICATIONS */
            var publications = document.getElementsByClassName('item-publications');
            var dotList = document.getElementsByClassName('dot-container');
            for (var d = 0; d < dotList.length; d++){
                var loop = function ( p ) {
                    var uniqueDot = document.createElement('div');
                    uniqueDot.classList.add('dot');
                    uniqueDot.setAttribute('data-id', 'publication-' + p);
                    if (p === d){
                        uniqueDot.classList.add('active');
                    }
                    dotList[d].append(uniqueDot);
                    uniqueDot.addEventListener('click', function(){
                        for (var p2 = 0; p2 < publications.length; p2++){
                            if (p2 !== p){
                                publications[p2].style.display = 'none';
                            }else {
                                publications[p2].style.display = 'flex';
                            }
                        }
                    });
                };

                for (var p = 0; p < publications.length; p++)loop( p );
            }
            var nbInterval = 0;
            setInterval(function(){
                var dotActive = document.querySelector('.dot.active');
                if (nbInterval === 2){
                    dotActive.previousSibling.previousSibling.click();
                    nbInterval = 0;
                }else {
                    dotActive.nextSibling.click();
                    nbInterval++;
                }
            }, 3000);
            var imagesPublications = document.getElementsByClassName('publication-home-image');
            for (var ip = 0; ip < imagesPublications.length; ip++) {
                imagesPublications[ip].addEventListener('click', function(e){
                    window.location.href = e.target.getAttribute('data-url');
                });
            }
        }

        /* CLIENT REFERENCES */
        var categories = document.getElementsByClassName('category-client');
        var clientItems = document.getElementsByClassName('client-item');
        var loop$1 = function ( c ) {
            categories[c].addEventListener('click', function(e){
                if (categories[c].getAttribute('id') === 'category-0' || categories[c].getAttribute('id') === 'category-1' ){
                    document.getElementsByClassName('clients')[0].style.justifyContent = 'normal';
                }else {
                    document.getElementsByClassName('clients')[0].style.justifyContent = 'center';
                }
                var activeCategory = document.querySelector('.category-client.active');
                activeCategory.classList.remove('active');
                categories[c].classList.add('active');
                for (var i = 0; i < clientItems.length; i++){
                    if (clientItems[i].classList.contains(categories[c].getAttribute('id'))){
                        clientItems[i].style.display = 'flex';
                    }else {
                        clientItems[i].style.display = 'none';
                    }
                }
            });
        };

        for (var c = 0; c < categories.length; c++)loop$1( c );

        /* PAGE EXPERTISE */
        var readMore = document.getElementsByClassName('read-more');
        var readLess = document.getElementsByClassName('read-less');
        var loop$2 = function ( r ) {
            readMore[r].addEventListener('click', function(){
                var id = readMore[r].getAttribute('id').split('read-more-')[1];
                var text = document.getElementById('read-more-text-' + id);
                text.style.display = 'block';
                readMore[r].style.display = 'none';
                readLess[r].style.display = 'block';

            });
        };

        for (var r = 0; r < readMore.length; r++)loop$2( r );
        var loop$3 = function ( rl ) {
            readLess[rl].addEventListener('click', function(){
                var id = readLess[rl].getAttribute('id').split('read-less-')[1];
                var text = document.getElementById('read-more-text-' + id);
                text.style.display = 'none';
                readLess[rl].style.display = 'none';
                readMore[rl].style.display = 'block';

            });
        };

        for (var rl = 0; rl < readLess.length; rl++)loop$3( rl );

        /* PAGE ACTUALITES */
        var moreActualities = document.getElementById('more-actualities');
        var page = 1; // What page we are on.
        var ppp = 6; // Post per page
        if (moreActualities){
            moreActualities.addEventListener('click', function(){
                var _data = { action : 'more_actualities_ajax', offset: ((page * ppp)), p: ppp};
                fetch(ajaxurl, {
                    method: 'POST',
                    body: (new URLSearchParams(_data)).toString(),
                    headers: { 'Content-type': 'application/x-www-form-urlencoded' }
                })
                    .then(function (response) { return response.text(); })
                    .then(function (result) { return document.getElementsByClassName('actualities')[0].insertAdjacentHTML("beforeend",result); })
                    .then(page++)
                    .then(function(){
                        var msnry = new Masonry( '.actualities', {
                            columnWidth: '.grid-sizer',
                            gutter: '.gutter-sizer',
                            horizontalOrder: true, // new!
                            percentPosition: true,
                        });
                    });


            });
        }
        var msnry = new Masonry( '.actualities', {
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer',
            horizontalOrder: true, // new!
            percentPosition: true,
        });

        /* PAGE PUBLICATIONS */
        var morePublications = document.getElementById('more-publications');
        var pagePublications = 1; // What page we are on.
        var pppPublications = 9; // Post per page
        if (morePublications){
            morePublications.addEventListener('click', function(){
                var _data = { action : 'more_publications_ajax', offset: ((pagePublications * pppPublications) + 1), p: pppPublications};
                fetch(ajaxurl, {
                    method: 'POST',
                    body: (new URLSearchParams(_data)).toString(),
                    headers: { 'Content-type': 'application/x-www-form-urlencoded' }
                })
                    .then(function (response) { return response.text(); })
                    .then(function (result) { return document.getElementsByClassName('publications-page')[0].insertAdjacentHTML("beforeend",result); })
                    .then(pagePublications++);
            });
        }
        var imagesPublicationsPage = document.getElementsByClassName('publication-page-image');
        for (var ipp = 0; ipp < imagesPublicationsPage.length; ipp++) {
            imagesPublicationsPage[ipp].addEventListener('click', function(e){
                window.location.href = e.target.getAttribute('data-url');
            });
        }

        /* SINGLE POST PAGE */
        var dots = document.getElementsByClassName('dot');
        var loop$4 = function ( d ) {
            dots[d].addEventListener('click', function(){
               var id = dots[d].getAttribute('data-id');
               var banners = document.querySelectorAll('.banner-image:not([id="' + id + '"])');
               var banner = document.querySelector('#' + id);
               banner.classList.add('show');
               banner.classList.remove('hide');
               for (var b = 0; b < banners.length; b++){
                  banners[b].classList.add('hide');
                  banners[b].classList.remove('show');
               }
               for (var d2 = 0; d2 < dots.length; d2++){
                   if (dots[d2].getAttribute('data-id') === id){
                       dots[d2].classList.add('active');
                   }else {
                       dots[d2].classList.remove('active');
                   }
               }
            });
        };

        for (var d$1 = 0; d$1 < dots.length; d$1++)loop$4( d$1 );
        var morePosts = document.getElementById('more-posts');
        var pagePosts = 1; // What page we are on.
        var pppPosts = 9; // Post per page
        if (morePosts){
            morePosts.addEventListener('click', function(){
                var _data = { action : 'more_publications_for_list_ajax', offset: ((pagePublications * pppPosts) + 1), p: pppPosts, post_id: document.getElementById('post-id').getAttribute('data-id')};
                fetch(ajaxurl, {
                    method: 'POST',
                    body: (new URLSearchParams(_data)).toString(),
                    headers: { 'Content-type': 'application/x-www-form-urlencoded' }
                })
                    .then(function (response) { return response.text(); })
                    .then(function (result) { return document.getElementsByClassName('posts-list')[0].insertAdjacentHTML("beforeend",result); })
                    .then(pagePosts++);
            });
        }
    });

})));
//# sourceMappingURL=nmsc.min.js.map
